import { render, staticRenderFns } from "./vSupplementLabelUS.vue?vue&type=template&id=5b79e188&scoped=true"
import script from "./vSupplementLabelUS.vue?vue&type=script&setup=true&lang=ts"
export * from "./vSupplementLabelUS.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./vSupplementLabelUS.vue?vue&type=style&index=0&id=5b79e188&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b79e188",
  null
  
)

export default component.exports